export default __webpack_public_path__ + "static/media/neet_mweb_banner_asset.b1347733.png";